import { render, staticRenderFns } from "./CeldaSelectorMultiple.vue?vue&type=template&id=2d6985ae&scoped=true"
import script from "./CeldaSelectorMultiple.vue?vue&type=script&lang=js"
export * from "./CeldaSelectorMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6985ae",
  null
  
)

export default component.exports